exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Text-module__text___2nhBo *{display:block}", ""]);

// exports
exports.locals = {
	"text": "Text-module__text___2nhBo"
};